<template>
  <div>
    <div class="container-fluid mt-2">
      <tabs tabNavClasses="flex-column flex-sm-row nav-wrapper"
        tabContentClasses="">
        <tab-pane id="create">
          <span slot="title">
              <!-- <i class="ni ni-cloud-upload-96"></i> -->
              Create New Form
          </span>
            
          <div class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
            <!-- <template slot="header">
              <h3 class="mb-0">Create Form</h3>
              <p class="text-sm mb-0">
                This is a client side example of paginated tables using element-ui tables.
              </p>
            </template> -->

            <div class="row">
              <div class="col-lg-9">
                <div class="card-wrapper">
                  <div class="card">
                    <div class="card-header">
                      <h3 class="mb-0">Fill up the form</h3>
                    </div>
                    <div class="card-body">
                      <form>
                        <span class="d-inline" style="line-height: 2.5rem;">
                          <select class="form-control form-control-sm d-inline w-auto mr-2" v-model="model.ca_type">
                            <option>I</option>
                            <option>We</option>
                          </select>
                          <span class="p">have examined the agreement (wherever applicable) between</span>
                          <select class="form-control form-control-sm d-inline w-auto mx-2"  v-model="model.remitter_salutation">
                            <option>Mr.</option>
                            <option>Ms.</option>
                            <option>M/s</option>
                          </select>
                          <base-input input-classes="form-control-sm w-auto mx-2 d-inline" class="inline-field" placeholder="name of remitter" v-model="model.remitter_pan"/>
                          <span class="p mr-2">with PAN/TAN</span>
                          <base-input input-classes="form-control-sm w-auto mr-2 d-inline" class="inline-field" placeholder="name of remitter" v-model="model.remitter_name"/>
                          <span class="p">and</span>
                          <select class="form-control form-control-sm d-inline w-auto mx-2" v-model="model.beneficiary_salutation">
                            <option>Mr.</option>
                            <option>Ms.</option>
                            <option>M/s</option>
                          </select>
                          <base-input input-classes="form-control-sm w-auto mr-2 d-inline" class="inline-field" placeholder="name of the beneficiary" v-model="model.beneficiary_name" />
                          <span class="p">requiring the above remittance as well as the relevant documents and books of account required for ascertaining the nature of remittance and for determining the rate of deduction of tax at source as per provisions of Charter- XVII-B.We hereby certify the following. </span>
                        </span>
                        <hr>
                        <div class="">
                          <p class="my-3 h3 font-weight-400">A Name and address of the beneficiary of the remittance</p>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Name of the Beneficiary of the remittance" placeholder="Name of the Beneficiary of the remittance" v-model="model.beneficiary_name"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Flat/Door/Building" placeholder="Flat/Door/Building" v-model="model.beneficiary_address_1"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Name of premises/Building/Village" placeholder="Name of premises/Building/Village" v-model="model.beneficiary_address_2"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Road/ Street" placeholder="Road/Street" v-model="model.beneficiary_address_3"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Areal/Locality" placeholder="Areal/Locality" v-model="model.beneficiary_area" />
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Town/City/District" placeholder="Town/City/District" v-model="model.beneficiary_city"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="State" placeholder="State" v-model="model.beneficiary_state"/>
                          <base-input label="Country" class="form-fields" labelClasses="align-self-center w-60 text-sm">
                            <select class="form-control" v-model="model.beneficiary_country">
                              <!-- <option>India</option> -->
                              <option v-for="currency in currencyData">{{currency.Country}}</option>
                              <!-- <option>UK</option> -->
                            </select>
                          </base-input>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="Zip code" placeholder="Zip code" v-model="model.beneficiary_zipcode"/>
                        </div>
                        <hr>
                        <div class="">
                          <p class="my-3 h3 font-weight-400">B Remittance Details</p>
                          <label class="col-form-label form-control-label font-weight-400">1. Country to which remittance is made</label>
                          <base-input label="Country" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3">
                            <select class="form-control" v-model="model.beneficiary_remittance_country">
                              <option v-for="currency in currencyData" :key="currency._id">{{currency.Country}}</option>
                              <!-- <option>India</option>
                              <option>USA</option>
                              <option>UK</option> -->
                            </select>
                          </base-input>
                          <base-input label="Currency" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3">
                            <select class="form-control" v-model="model.beneficiary_remittance_currency">
                              <option v-for="currency in currencyData" :key="currency._id">{{currency.Currency_Code}}</option>
                              <!-- <option>RUPEE</option>
                              <option>DOLLAR</option>
                              <option>HKD</option> -->
                            </select>
                          </base-input>
                          <label class="col-form-label form-control-label font-weight-400">2. Amount Payable</label>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="In foreign currency" placeholder="In foreign currency" v-model="model.amount_payble_foreign"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="In Indian Rs" placeholder="In Indian Rs" v-model="model.amount_payble_rupee"/>
                          <base-input label="3. Name of the bank" class="form-fields" labelClasses="align-self-center w-60 text-sm" >
                            <select class="form-control" v-model="model.bank_name" @change="getbankbranch()">
                              <option value="">Select bank</option>
                              <option v-for="bank in bankData" :key="bank._id" :value="bank.BANK_NAME">{{bank.BANK_NAME}}</option>
                              <!-- <option>DOLLAR</option>
                              <option>HKD</option> -->
                            </select>
                          </base-input>
                          <base-input label="Branch of the bank" class="form-fields" labelClasses="align-self-center w-60 text-sm" >
                            <select class="form-control" v-model="model.branch_name" @change="getBSRcodeofbranch()">
                              <option value="">Select branch</option>
                              <option v-for="branch in branchData" :key="branch._id" :value="branch.BANK_BRANCH_NAME+'#'+branch.BSR_CODE">{{branch.BANK_BRANCH_NAME}}</option>
                              <!-- <option>DOLLAR</option>
                              <option>HKD</option> -->
                            </select>
                          </base-input>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="4. BSR Code of the bank branch (7 digit)" placeholder="BSR Code of the bank branch (7 digit)" v-model="model.bank_bsr_code"/>
                          <base-input type="date" labelClasses="align-self-center w-60 text-sm" input-classes="form-control" label="5 Proposed date of remittance " class="form-fields" value="2018-11-23" id="example-date-input" v-model="model.proposed_remittance_date"/>
                          <base-input label="6. Nature of remittance as per agreement/document" class="form-fields" labelClasses="align-self-center w-60 text-sm">
                            <select class="form-control" v-model="model.nature_of_remittance">
                              <option>ADVERTISEMENT FEE</option>
                              <option>AMC CHARGES</option>
                              <option>BANDWIDTH CHARGES</option>
                            </select>
                          </base-input>
                          <base-input label="7. Please furnish the relevant purpose code as per RBI" class="form-fields" labelClasses="align-self-center w-60 text-sm">
                            <select class="form-control" v-model="model.purpose_code_part1">
                              <option>CAPITAL ACCOUNT</option>
                              <option>FDI</option>
                              <option>BANKING CAPITAL</option>
                            </select>
                          </base-input>
                          <base-input label=" " class="form-fields" labelClasses="align-self-center w-60 text-sm">
                            <select class="form-control" v-model="model.purpose_code_part2">
                              <option>ACQUISITION OF NON-PRODUCED NON-FINANCIAL ASSETS</option>
                              <option>FDI</option>
                              <option>BANKING CAPITAL</option>
                            </select>
                          </base-input>
                          <base-input label="In case the remittance is net of taxes, whether tax payable has been grossed up? " class="form-fields" labelClasses="align-self-center w-60 text-sm px-3">
                            <base-radio v-model="model.remittance_net_tax"
                                        name="unchecked"
                                        class="mt-2 w-50 float-left">
                              Yes
                            </base-radio>

                            <base-radio v-model="model.remittance_net_tax"
                                        name="checked"
                                        class="mt-2 w-50 float-right">
                              No
                            </base-radio>
                          </base-input>
                          <label class="col-form-label form-control-label font-weight-400 mt-4 mb-2">8. Taxability under the provisions of the Income-tax Act (without considering DTAA)</label>
                          <base-input label="(i) is remittance chargeable to tax in India" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" >
                            <base-radio v-model="model.is_remittance_taxed"
                                        :name="true"
                                        class="mt-2 w-50 float-left" >
                              Yes
                            </base-radio>

                            <base-radio v-model="model.is_remittance_taxed"
                                        :name="false"
                                        class="mt-2 w-50 float-right">
                              No
                            </base-radio>
                          </base-input>
                          <!-- {{model.is_remittance_taxed}} -->
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(ii) if not reasons thereof" placeholder="" id="no_tax_reasons" v-model="model.no_tax_reasons" :disabled="model.is_remittance_taxed"/>
                          <div id="ifyes8">
                          <label class="col-form-label form-control-label font-weight-400 pl-3">(iii) if yes</label>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(a) the relevant section of the Act under which the remittance is covered"  placeholder="" v-model="model.remittance_act" :disabled="!model.is_remittance_taxed"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(b) the amount of income chargeable to tax" placeholder="" v-model="model.taxable_income" :disabled="!model.is_remittance_taxed"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(c) the tax liability" placeholder="" v-model="model.tax_liability" :disabled="!model.is_remittance_taxed"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(d) basis of determining taxable income and tax liability" placeholder="" v-model="model.basis_of_determining_taxable" :disabled="!model.is_remittance_taxed"/>
                        </div>
                          <label class="col-form-label form-control-label font-weight-400 mt-4 mb-2">9. If income is chargeable to tax in India and any relief is claimed under DTAA</label>
                          <base-input label="(i) whether tax residency certificate is obtained from the recipient of remittance" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3">
                            <base-radio v-model="model.tax_residency_certificate"
                                        :name="true"
                                        class="mt-2 w-50 float-left">
                              Yes
                            </base-radio>

                            <base-radio v-model="model.tax_residency_certificate"
                                        :name="false"
                                        class="mt-2 w-50 float-right">
                              No
                            </base-radio>
                          </base-input>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(ii) please specify relevant DTAA" placeholder="" v-model="model.relevant_dtaa" />
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(iii) please specify relevant article of DTAA" placeholder="" v-model="model.article_of_dtaa"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(iv) taxable income as per DTAA" placeholder="" v-model="model.taxable_income_dtaa"/>
                          <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(v) tax liability as per DTAA" placeholder="" v-model="model.tax_liability_dtaa"/>
                        </div>
                        <base-input label="A. If the remittance is for royalties, fee for technical services, interest, dividend, etc, (not connected with permanent establishment) please indicate" class="form-fields" labelClasses="align-self-center w-60 text-sm mt-3 px-3">
                          <base-radio v-model="model.remittance_nature_9a"
                                      :name="true"
                                      class="mt-3 w-50 float-left">
                            Yes
                          </base-radio>

                          <base-radio v-model="model.remittance_nature_9a"
                                      :name="false"
                                      class="mt-3 w-50 float-right">
                            No
                          </base-radio>
                        </base-input>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm pl-3" label="(a) Article of DTAA" placeholder="" v-model="model.article_dtaa_9a" :disabled="!model.remittance_nature_9a"/>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(b) Rate of TDS required to be deducted in terms of such aiticle of the applicable DTAA" placeholder="" v-model="model.tds_rate_9a" :disabled="!model.remittance_nature_9a"/>
                        <base-input label="B. In case the remittance is on account of business income, please indicate" class="form-fields" labelClasses="align-self-center w-60 text-sm mt-3 px-3">
                          <base-radio v-model="model.remittance_business_account_9b"
                                      :name="true"
                                      class="mt-3 w-50 float-left">
                            Yes
                          </base-radio>

                          <base-radio v-model="model.remittance_business_account_9b"
                                      :name="false"
                                      class="mt-3 w-50 float-right">
                            No
                          </base-radio>
                        </base-input>
                        <base-input label="(a) Whether such income is liable to tax in India" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3">
                          <base-radio v-model="model.tax_liable_9b"
                                      :name="true"
                                      class="mt-1 w-50 float-left" :disabled="!model.remittance_business_account_9b">
                            Yes
                          </base-radio>

                          <base-radio v-model="model.tax_liable_9b"
                                      :name="false"
                                      class="mt-1 w-50 float-right" :disabled="!model.remittance_business_account_9b">
                            No
                          </base-radio>
                        </base-input>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(b) If so, the basis of arriving at the rate of deduction of tax." placeholder="" v-model="model.tax_basis_9b" :disabled="!model.tax_liable_9b"/>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(c) If not, the please furnish brief reasons thereof. specifying relevant aiticle of DTAA" placeholder="" v-model="model.article_dtaa_9b" :disabled="!model.tax_liable_9b"/>

                        <base-input label="C. In case the remittance is on account of capital gains, please indicate" class="form-fields" labelClasses="align-self-center w-60 text-sm mt-3 px-3">
                          <base-radio v-model="model.remittance_capital_gains_9c"
                                      :name="true"
                                      class="mt-3 w-50 float-left">
                            Yes
                          </base-radio>

                          <base-radio v-model="model.remittance_capital_gains_9c"
                                      :name="false"
                                      class="mt-3 w-50 float-right">
                            No
                          </base-radio>
                        </base-input>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(a) amount of long term capital gains" placeholder="" v-model="model.long_term_capital_amount_9c" :disabled="!model.remittance_capital_gains_9c"/>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(b) amount of short-term capital gains" placeholder="" v-model="model.short_term_capital_amount_9c" :disabled="!model.remittance_capital_gains_9c"/>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(c) basis of arriving at taxable income" placeholder="" v-model="model.tax_basis_9c" :disabled="!model.remittance_capital_gains_9c"/>

                        <base-input label="D. In case of other remittance not covered by sub-items A,B and C" class="form-fields" labelClasses="align-self-center w-60 text-sm mt-3 px-3">
                          <base-radio v-model="model.remittance_not_covered_9d"
                                      :name="true"
                                      class="mt-3 w-50 float-left">
                            Yes
                          </base-radio>

                          <base-radio v-model="model.remittance_not_covered_9d"
                                      :name="false"
                                      class="mt-3 w-50 float-right">
                            No
                          </base-radio>
                        </base-input>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(a) Please specify nature of remittance" placeholder="" v-model="model.nature_of_remittance_9d" :disabled="!model.remittance_not_covered_9d"/>
                        <base-input label="(b) Whether taxable in India as per DTAA" class="form-fields" labelClasses="align-self-center w-60 text-sm mt-3 px-3">
                          <base-radio v-model="model.taxability_9d"
                                      :name="true"
                                      class="mt-3 w-50 float-left">
                            Yes
                          </base-radio>

                          <base-radio v-model="model.taxability_9d"
                                      :name="false"
                                      class="mt-3 w-50 float-right">
                            No
                          </base-radio>
                        </base-input>

                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(c) If yes, rate of TDS required to be deducted in terms of such aiticle of the applicable DTAA" placeholder="" v-model="model.tds_rate_9d" :disabled="!model.taxability_9d"/>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="(d) if not , the please furnish brief reasons thereof. specifying relevant article of DTAA" placeholder="" v-model="model.reason_9d" :disabled="!model.taxability_9d" />

                        <!-- 10th point -->
                        <label class="col-form-label form-control-label font-weight-400 mt-4">10. Amount of TDS</label>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="In foreign currency" placeholder="" v-model="model.tds_foreign_10"/>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label="In Indian Rs" placeholder="" v-model="model.tds_rupee_10"/>

                        <!-- 11th point -->
                        <base-input label="11. Rate of TDS" class="form-fields" labelClasses="align-self-center w-60 text-sm">
                          <select class="form-control" v-model="model.tds_rate_11">
                            <option>SELECT</option>
                            <option>AS PER INCOME-TAX ACT</option>
                            <option>AS PER DTAA</option>
                          </select>
                        </base-input>
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm px-3" label=" " placeholder="" v-model="model.tds_op2_11"/>

                        <!-- 12th point -->
                        <base-input input-classes="form-control" class="form-fields" labelClasses="align-self-center w-60 text-sm" label="12. Actual amount of remittance after TDS (In foreign currency) " placeholder="" v-model="model.actual_remittance"/>

                        <!-- 13th point -->
                        <base-input type="date" labelClasses="align-self-center w-60 text-sm" input-classes="form-control" label="13. Date of deduction of tax at source, if any " class="form-fields" value="2018-11-23" id="example-date-input" v-model="model.tax_deduction_date"/>

                        <hr>
                        <p class="my-5 h3 font-weight-400"></p>
                        <div>
                          <base-input input-classes="form-control form-control-sm" class="line-fields" labelClasses="align-self-center w-60 mb-0 text-sm" label="Accountant Name" placeholder="" v-model="model.ca_name"/>
                          <base-input input-classes="form-control form-control-sm" class="line-fields" labelClasses="align-self-center w-60 mb-0 text-sm" label="Name of the proprietorship/ firm" placeholder="" v-model="model.firm_name"/>
                          <base-input input-classes="form-control form-control-sm" class="line-fields" labelClasses="align-self-center w-60 mb-0 text-sm" label="Address" placeholder="" v-model="model.address"/>
                          <base-input input-classes="form-control form-control-sm" class="line-fields" labelClasses="align-self-center w-60 mb-0 text-sm" label="Membership No" placeholder="" v-model="model.membership_no"/>
                          <base-input input-classes="form-control form-control-sm" class="line-fields" labelClasses="align-self-center w-60 mb-0 text-sm" label="Registration No" placeholder="" v-model="model.registration_no"/>
                          <base-input input-classes="form-control form-control-sm" class="line-fields" labelClasses="align-self-center w-60 mb-0 text-sm" label="Certificate No" placeholder="" v-model="model.certificate_no"/>
                        </div>
                        <div class="mt-4">
                          <base-button type="primary" block size="lg" id="saveuserbtn" @click="saveform()">Save Form</base-button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="card-wrapper">
                  <!-- Sizes -->
                  <div class="">
                    <!-- Card header -->
                    <div class="">
                      <h3 class="mb-0">Validations</h3>
                    </div>
                    <!-- Card body -->
                    <div class="mt-2">
                      <span class="text-danger text-sm">See changes as they’re made and save time by working together. Real-time collaboration is enabled for all Canva designs.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
        <tab-pane id="allforms">
          <span slot="title">
              <!-- <i class="ni ni-calendar-grid-58"></i> -->
              Saved Forms
          </span>
          <div class="row">
            <div class="col-lg-6" v-for="form15cb in form15cbData">
              <card>
                <!-- Card body -->
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="data-pointer">
                      <div class="top-month">
                        <span>Jan</span>
                      </div>
                      <div class="bottom-date">
                        <span>15</span>
                      </div>
                    </div>
                  </div>
                  <div class="col ml--2">
                    <h4 class="mb-0">
                      <span>Remittance to {{form15cb.remitter_name}}</span>
                    </h4>
                    <p class="text-sm text-muted mb-2">{{form15cb.beneficiary_country}}  ●  ₹1200</p>
                    <span class="text-success mr-1">
                      <i class="fas fa-arrow-down align-middle"></i>
                    </span>
                    <small>Download PDF</small>
                  </div>
                  <div class="col-auto">
                    <base-button type="primary" size="sm">View Form</base-button>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
  import FileInput from '@/components/Inputs/FileInput'
  import { Tabs } from '@/components';
  import VueSwal from 'vue-swal';
  import axios from "axios";
  export default {
    name: 'form-elements',
    components: {
      FileInput,
      Tabs
    },
    data() {
      return {
        inputs: {
          file: []
        },
        currencyData:[],
        form15cbData:[],
        bankData:[],
        branchData:[],
        model:{
          ca_type: '',
          remitter_salutation: '',
          remitter_name: '',
          remitter_pan: '',
          beneficiary_salutation: '',
          beneficiary_name: '',
          beneficiary_address_1 : '',
          beneficiary_address_2 : '',
          beneficiary_address_3 : '',
          beneficiary_area : '',
          beneficiary_city : '',
          beneficiary_state : '',
          beneficiary_country : 'India',
          beneficiary_zipcode : '',
          beneficiary_remittance_country : '',
          beneficiary_remittance_currency : '',
          amount_payble_foreign : '',
          amount_payble_rupee : '',
          bank_name : '',
          branch_name : '',
          bank_bsr_code : '',
          proposed_remittance_date : '',
          nature_of_remittance : '',
          purpose_code_part1 : '',
          purpose_code_part2 : '',
          remittance_net_tax : '',
          is_remittance_taxed : '',
          no_tax_reasons : '',
          remittance_act : '',
          taxable_income : '',
          tax_liability : '',
          basis_of_determining_taxable : '',
          tax_residency_certificate : '',
          relevant_dtaa : '',
          article_of_dtaa : '',
          taxable_income_dtaa : '',
          tax_liability_dtaa : '',
          remittance_nature_9a : '',
          article_dtaa_9a : '',
          tds_rate_9a : '',
          tds_rate_9a : '',
          remittance_business_account_9b :'',
          tax_liable_9b : '',
          tax_basis_9b : '',
          article_dtaa_9b : '',
          remittance_capital_gains_9c : '',
          long_term_capital_amount_9c : '',
          short_term_capital_amount_9c : '',
          tax_basis_9c : '',
          remittance_not_covered_9d : '',
          nature_of_remittance_9d : '',
          taxability_9d : '',
          tds_rate_9d : '',
          reason_9d : '',
          tds_foreign_10 : '',
          tds_rupee_10 : '',
          tds_rate_11 : '',
          tds_op2_11 : '',
          actual_remittance : '',
          tax_deduction_date : '',
          ca_name : '',
          firm_name : '',
          address : '',
          membership_no : '',
          registration_no : '',
          certificate_no : '',
          udin : '',
          ca_signature : '',
          attachments : [],
          status : 'approved',
        },
        checkboxes: {
          unchecked: false,
          checked: true,
          uncheckedDisabled: false,
          checkedDisabled: true
        },
        radios: {
          radio1: 'checked',
          radio2: 'checked'
        },
        auth : {
          headers: { 'Content-Type':'application/x-www-form-urlencoded',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
      auth1 : { headers: { 'Content-Type':'application/json',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
      }
    },
    mounted () {

      const querystring = require('querystring');
      console.log(this.auth);
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_currency',{ "details" :{}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.currencyData=response.data.details;
        }
            
      })
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_banklist',{ "details" :{}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.bankData=response.data.details;
        }
            
      })

      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_form15cb',{ "details" :{}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.form15cbData=response.data.details;
        }
            
      })

    },
    methods: {

      filesChange(files) {
        this.inputs.file = files
      },
      getbankbranch(){
            
            axios
              .post(process.env.VUE_APP_API_ENDPOINT+'read_bank',{ "details" :{"BANK_NAME":this.model.bank_name}},this.auth1)
              .then(response => {
                console.log(response);
                if(response.data.details){
                this.branchData=response.data.details;
                }
                    
              })
      },
      getBSRcodeofbranch(){

        let branchdata=this.model.branch_name.split('#');
            this.model.bank_bsr_code=branchdata[1];
      },
      saveform(){
            document.getElementById("saveuserbtn").innerHTML='Loading...';
            
            const querystring = require('querystring');
            if(this.model.branch_name){
              let branchdata=this.model.branch_name.split('#');
              this.model.branch_name=branchdata[0];
            }
            
            axios.post(process.env.VUE_APP_API_ENDPOINT+'create_form15cb',querystring.stringify({ca_type: this.model.ca_type,remitter_salutation: this.model.remitter_salutation,remitter_name: this.model.remitter_pan,remitter_pan: this.model.remitter_pan,beneficiary_salutation: this.model.beneficiary_salutation,beneficiary_name: this.model.beneficiary_name, beneficiary_address_1 : this.model.beneficiary_address_1,beneficiary_address_2 : this.model.beneficiary_address_2, beneficiary_address_3 : this.model.beneficiary_address_3,beneficiary_area : this.model.beneficiary_area,beneficiary_city : this.model.beneficiary_city,beneficiary_state : this.model.beneficiary_state,beneficiary_country : this.model.beneficiary_country,beneficiary_zipcode : this.model.beneficiary_zipcode,beneficiary_remittance_country : this.model.beneficiary_remittance_country,beneficiary_remittance_currency : this.model.beneficiary_remittance_currency,amount_payble_foreign : this.model.amount_payble_foreign,amount_payble_rupee : this.model.amount_payble_rupee,bank_name : this.model.bank_name,branch_name : this.model.branch_name,bank_bsr_code : this.model.bank_bsr_code,proposed_remittance_date : this.model.proposed_remittance_date,nature_of_remittance : this.model.nature_of_remittance,purpose_code_part1 : this.model.purpose_code_part1,purpose_code_part2 : this.model.purpose_code_part2,remittance_net_tax : this.model.remittance_net_tax,is_remittance_taxed : this.model.is_remittance_taxed,no_tax_reasons : this.model.no_tax_reasons,remittance_act : this.model.remittance_act,taxable_income : this.model.taxable_income,tax_liability : this.model.tax_liability,basis_of_determining_taxable : this.model.basis_of_determining_taxable,tax_residency_certificate : this.model.tax_residency_certificate,relevant_dtaa : this.model.relevant_dtaa,article_of_dtaa : this.model.article_of_dtaa,taxable_income_dtaa : this.model.taxable_income_dtaa,tax_liability_dtaa : this.model.tax_liability_dtaa,remittance_nature_9a : this.model.remittance_nature_9a,article_dtaa_9a : this.model.article_dtaa_9a,tds_rate_9a : this.model.tds_rate_9a,remittance_business_account_9b : this.model.remittance_business_account_9b,tax_liable_9b : this.model.tax_liable_9b,tax_basis_9b : this.model.tax_basis_9b,article_dtaa_9b : this.model.article_dtaa_9b,remittance_capital_gains_9c : this.model.remittance_capital_gains_9c,long_term_capital_amount_9c : this.model.long_term_capital_amount_9c,short_term_capital_amount_9c : this.model.short_term_capital_amount_9c,tax_basis_9c : this.model.tax_basis_9c,remittance_not_covered_9d : this.model.remittance_not_covered_9d,nature_of_remittance_9d : this.model.nature_of_remittance_9d,taxability_9d : this.model.taxability_9d,tds_rate_9d : this.model.tds_rate_9d,reason_9d : this.model.reason_9d,tds_foreign_10 : this.model.tds_foreign_10,tds_rupee_10 : this.model.tds_rupee_10,tds_rate_11 : this.model.tds_rate_11,tds_op2_11 : this.model.tds_op2_11,actual_remittance : this.model.actual_remittance,tax_deduction_date : this.model.tax_deduction_date,ca_name : this.model.ca_name,firm_name : this.model.firm_name,address : this.model.address,membership_no : this.model.membership_no,registration_no : this.model.registration_no,certificate_no : this.model.certificate_no,udin : this.model.udin,ca_signature : this.model.ca_signature,attachments : this.model.attachments,status : this.model.status}),this.auth1)
          .then(response => {
            
              document.getElementById("saveuserbtn").classList.remove('btn-primary');
              document.getElementById("saveuserbtn").classList.add('btn-success');
              document.getElementById("saveuserbtn").innerHTML='Updated';
              setTimeout(function(){
              document.getElementById("saveuserbtn").classList.remove('btn-success');
              document.getElementById("saveuserbtn").classList.add('btn-primary');
              document.getElementById("saveuserbtn").innerHTML="Update business";
              //window.location.reload()
            }, 2000);
            })
    },
  }
}
</script>
<style>
.data-pointer {
  border: 3px solid #5e72e4;
  border-radius: 15px;
}
.top-month {
  padding: 2px 12px;
  text-align: center;
}
.bottom-date {
    padding: 1px 15px;
    background-color: #5e72e4;
    border-radius: 0 0 6px 6px;
    color: white;
    text-align: center;
    font-weight: bold;
    font-size: x-large;
}
</style>